<!--
 * Author: kunnisser
 * Date: 2020-07-15 10:46:25
 * @LastEditors: kunnisser
 * @LastEditTime: 2020-08-03 16:56:06
 * @FilePath: /app_h5/src/App.vue
 * Description: ---- 项目UI入口 ----
 -->

<template>
  <div id="app">
  <keep-alive>
    <router-view v-if="$route.meta.keepAlive"/>
  </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    if (this.$isDesktop) {
      const appNode = document.getElementById('app');
      appNode.style.minWidth = '320px';
      appNode.style.maxWidth = '320px';
    }
  }
}
</script>
<style lang="stylus">
@import '~@assets/stylus/base.styl';
#app
  height 100vh
  margin 0 auto
</style>



// WEBPACK FOOTER //
// src/App.vue